import Vue from 'vue';
import { client } from '@/store';

export default {
	namespaced: true,

	state: {
		users: [],
		privileges: [],
		tags: [],
		tagColors: [],
	},

	// sync actions
	mutations: {
		setUsers(state, value) {
			state.users = value;
		},

		setPrivileges(state, value) {
			state.privileges = value;
		},

		updateUser(state, value) {
			const index = state.users.findIndex(item => item.id === value.user.id);
			Vue.set(state.users, index, value.user);
		},

		addUser(state, value) {
			state.users.push(value.user);
		},

		deleteUser(state, value) {
			const index = state.users.findIndex(item => item.id === value.id);
			Vue.delete(state.users, index);
		},
		setTags(state, value) {
			state.tags = value
		},
		setTagColors(state, value) {
			state.tagColors = value
		}
	},

	actions: {
		createUser({ commit, state, dispatch }, data) {
			const query = `
			mutation ($username: String!, $password: String!, $gripp_employee_id: Int, $role_id: Int, $gripp_tag_id: String, $google_calendar_id: String, $hex_color: String, $display_name: String, $branch: String, $email: String, $employee_status: String, $phone: String, $employer: String, $can_install_ventilatieroosters: Boolean) {
				user: createUser(username: $username, password: $password, gripp_employee_id: $gripp_employee_id, role_id: $role_id, gripp_tag_id: $gripp_tag_id, google_calendar_id: $google_calendar_id, hex_color: $hex_color, display_name: $display_name, branch: $branch, email: $email, employee_status: $employee_status, phone: $phone, employer: $employer, can_install_ventilatieroosters: $can_install_ventilatieroosters) {
					id
					display_name
					username
					gripp_employee_id
					hex_color
					role_id
					google_calendar_id
					gripp_tag_id
					branch
					email
					employee_status
					phone
					employer
					can_install_ventilatieroosters
					privileges {
						id
						allowed
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('addUser', {
						id: result.user.id,
						user: result.user
					});
					resolve(result.user);
				})
					.catch((error) => {
						reject(error);
						commit('setIdle', null, { root: true });
					});
			});
		},

		changeUser({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!, $username: String, $password: String, $gripp_employee_id: Int, $role_id: Int $google_calendar_id: String, $hex_color: String, $display_name: String, $gripp_tag_id: String, $branch: String, $email: String, $employee_status: String, $phone: String, $employer: String, $can_install_ventilatieroosters: Boolean) {
				user: changeUser(id: $id, username: $username, password: $password, gripp_employee_id: $gripp_employee_id, role_id: $role_id, google_calendar_id: $google_calendar_id, hex_color: $hex_color, display_name: $display_name, gripp_tag_id: $gripp_tag_id, branch: $branch, email: $email, employee_status: $employee_status, phone: $phone, employer: $employer, can_install_ventilatieroosters: $can_install_ventilatieroosters) {
					id
					display_name
					username
					gripp_employee_id
					hex_color
					role_id
					google_calendar_id
					gripp_tag_id
					branch
					email
					employee_status
					phone
					employer
					can_install_ventilatieroosters
					privileges {
						id
						allowed
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateUser', {
						id: result.user.id,
						user: result.user
					});
					resolve(result.user);
				})
					.catch((error) => {
						reject(error);
						commit('setIdle', null, { root: true });
					});
			});
		},

		deleteUser({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!) {
				deleteUser(id: $id)
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('deleteUser', {
						id: data.id,
					});
					resolve();
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},

		changeUserPrivileges({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!, $privileges: [PrivilegeInput]) {
				user: changeUserPrivileges(id: $id, privileges: $privileges) {
					id
					display_name
					username
					gripp_employee_id
					hex_color
					role_id
					google_calendar_id
					gripp_tag_id
					branch
					email
					employee_status
					phone
					employer
					privileges {
						id
						allowed
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateUser', {
						id: result.user.id,
						user: result.user
					});
					resolve(result.user);
				})
				.catch((error) => {
					reject(error);
					commit('setIdle', null, { root: true });
				});
			});
		},


		get2faSecret({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!) {
				configureUser2fa(id: $id) {
					id
					otp_secret 
					qrCodeUri
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					resolve(result.configureUser2fa);
				})
					.catch((error) => {
						reject(error);
						commit('setIdle', null, { root: true });
					});
			});

		},

		enableUser2fa({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!, $code: String) {
				enableUser2fa(id: $id, code: $code)
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateUser', {
						id: data.id,
						user: {
							is_2fa_configured: true
						}
					});
					resolve(true);
				})
					.catch((error) => {
						reject(error);
						commit('setIdle', null, { root: true });
					});
			});

		},

		disableUser2fa({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!) {
				disableUser2fa(id: $id)
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('updateUser', {
						id: data.id,
						user: {
							is_2fa_configured: false
						}
					});
					resolve(true);
				})
					.catch((error) => {
						reject(error);
						commit('setIdle', null, { root: true });
					});
			});

		},

		fetchAllhUsersWithPrivileges({ commit, state, dispatch }, data) {
			const markersQuery = `
			query($role: String) {
				users(role: $role) {
					id
					display_name
					username
					gripp_employee_id
					is_2fa_configured
					hex_color
					role_id
					gripp_tag_id
					google_calendar_id
					branch
					email
					employee_status
					phone
					employer,
					can_install_ventilatieroosters
					privileges {
						id
						allowed
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setUsers', result.users);
					resolve(result.users);
				});
			});
		},

		fetchAllPrivileges({ commit, state, dispatch }, data) {
			const markersQuery = `
			query {
				privileges {
					id
					depth
					name
					label
					description
					allowed
					parent_id
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(markersQuery, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					commit('setPrivileges', result.privileges);
					resolve(result.privileges);
				});
			});
		},

		fetchEmployees({ commit, state, dispatch }) {
			const query = `
			query {
				employees {
					id
					fullname
					active
				}
			}`;

			return new Promise((resolve, reject) => {
				// commit('setLoading', null, { root: true });
				client.query(query).then(result => {
					// commit('setIdle', null, { root: true });
					resolve(result.employees.filter(e => e.active));
				});
			});
		},

		getAllCompaniesWithoutGeo({ commit, state, dispatch }, data) {
			const query = `
			query {
				companiesWithoutGeo {
					id
					companyname
					salutation
					initials
					infix
					lastname
					visitingaddress_street
					visitingaddress_streetnumber
					visitingaddress_city
					visitingaddress_zipcode
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit('setIdle', null, { root: true });
					resolve(result.companiesWithoutGeo);
				});
			});
		},

		changeCompanyGeo({ commit, state, dispatch }, data) {
			const query = `
			mutation ($id: ID!) {
				company: changeCompanyGeo(id: $id) {
					id
					visitingaddress_lat
					visitingaddress_lng
				}
			}`;

			return new Promise((resolve, reject) => {
				client.query(query, { ...data }).then(result => {
					resolve(result.company);
				})
				.catch((error) => {
					reject(error);
				});
			});
		},
		fetchTags({ commit, state, dispatch }) {
			const query = `
			query {
				tags {
					id
					name
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query).then(result => {
					commit("setTags", result.tags);
					commit('setIdle', null, { root: true });
					resolve(result.tags);
				});
			});
		},

		fetchTagColors({ commit, state, dispatch }) {
			const query = `
			query {
				tagColors {
					id
					tag_id
					color
					order
					lead_channel {
						id
						name
					}
					tag {
						id
						name
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query).then(result => {
					commit("setTagColors", result.tagColors);
					commit('setIdle', null, { root: true });
					resolve(result.tagColors);
				});
			});
		},
		changeTagColors({ commit, state, dispatch }, data) {
			const query = `
			mutation ($delete: [ID], $update: [TagColorInput]) {
				tagColor: changeTagColors(delete: $delete, update: $update) {
					id
					tag_id
					color
					order
					lead_channel {
						id
						name
					}
					tag {
						id
						name
					}
				}
			}
			`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, { ...data }).then(result => {
					commit("setTagColors", result.tagColor);
					commit('setIdle', null, { root: true });
					resolve(result.tagColor);
				});
			});
		}
	}
};
